import { __read } from "tslib";
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
export var UP = 'up';
export var DOWN = 'down';
export var NONE = 'none';
var INITIAL_BOTTOM_STATE = {
    atBottom: false,
    notAtBottomBecause: 'NOT_SHOWING_LAST_ITEM',
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0,
    },
};
export var stateFlagsSystem = u.system(function (_a) {
    var _b = __read(_a, 1), _c = _b[0], scrollContainerState = _c.scrollContainerState, scrollTop = _c.scrollTop, viewportHeight = _c.viewportHeight, headerHeight = _c.headerHeight, footerHeight = _c.footerHeight, scrollBy = _c.scrollBy;
    var isAtBottom = u.statefulStream(false);
    var isAtTop = u.statefulStream(true);
    var atBottomStateChange = u.stream();
    var atTopStateChange = u.stream();
    var atBottomThreshold = u.statefulStream(4);
    // skip 1 to avoid an initial on/off flick
    var isScrolling = u.streamFromEmitter(u.pipe(u.merge(u.pipe(u.duc(scrollTop), u.skip(1), u.mapTo(true)), u.pipe(u.duc(scrollTop), u.skip(1), u.mapTo(false), u.debounceTime(100))), u.distinctUntilChanged()));
    var isScrollingBy = u.statefulStreamFromEmitter(u.pipe(u.merge(u.pipe(scrollBy, u.mapTo(true)), u.pipe(scrollBy, u.mapTo(false), u.debounceTime(200))), u.distinctUntilChanged()), false);
    // u.subscribe(isScrollingBy, (isScrollingBy) => console.log({ isScrollingBy }))
    u.connect(u.pipe(u.duc(scrollTop), u.map(function (top) { return top === 0; }), u.distinctUntilChanged()), isAtTop);
    u.connect(isAtTop, atTopStateChange);
    var atBottomState = u.streamFromEmitter(u.pipe(u.combineLatest(scrollContainerState, u.duc(viewportHeight), u.duc(headerHeight), u.duc(footerHeight), u.duc(atBottomThreshold)), u.scan(function (current, _a) {
        var _b = __read(_a, 5), _c = _b[0], scrollTop = _c.scrollTop, scrollHeight = _c.scrollHeight, viewportHeight = _b[1], _headerHeight = _b[2], _footerHeight = _b[3], atBottomThreshold = _b[4];
        var isAtBottom = scrollTop + viewportHeight - scrollHeight > -atBottomThreshold;
        var state = {
            viewportHeight: viewportHeight,
            scrollTop: scrollTop,
            scrollHeight: scrollHeight,
        };
        if (isAtBottom) {
            var atBottomBecause = void 0;
            var scrollTopDelta = void 0;
            if (scrollTop > current.state.scrollTop) {
                atBottomBecause = 'SCROLLED_DOWN';
                scrollTopDelta = current.state.scrollTop - scrollTop;
            }
            else {
                atBottomBecause = 'SIZE_DECREASED';
                scrollTopDelta =
                    current.state.scrollTop - scrollTop ||
                        current.scrollTopDelta;
            }
            return {
                atBottom: true,
                state: state,
                atBottomBecause: atBottomBecause,
                scrollTopDelta: scrollTopDelta,
            };
        }
        var notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) {
            notAtBottomBecause = 'SIZE_INCREASED';
        }
        else if (viewportHeight < current.state.viewportHeight) {
            notAtBottomBecause = 'VIEWPORT_HEIGHT_DECREASING';
        }
        else if (scrollTop < current.state.scrollTop) {
            notAtBottomBecause = 'SCROLLING_UPWARDS';
        }
        else {
            notAtBottomBecause = 'NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM';
        }
        return {
            atBottom: false,
            notAtBottomBecause: notAtBottomBecause,
            state: state,
        };
    }, INITIAL_BOTTOM_STATE), u.distinctUntilChanged(function (prev, next) {
        return prev && prev.atBottom === next.atBottom;
    })));
    var lastJumpDueToItemResize = u.statefulStreamFromEmitter(u.pipe(scrollContainerState, u.scan(function (current, _a) {
        var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, viewportHeight = _a.viewportHeight;
        if (current.scrollHeight !== scrollHeight) {
            var atBottom = scrollTop === scrollHeight - viewportHeight;
            if (current.scrollTop !== scrollTop && atBottom) {
                return {
                    scrollHeight: scrollHeight,
                    scrollTop: scrollTop,
                    jump: current.scrollTop - scrollTop,
                    changed: true,
                };
            }
            return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop,
                jump: 0,
                changed: true,
            };
        }
        return {
            scrollTop: scrollTop,
            scrollHeight: scrollHeight,
            jump: 0,
            changed: false,
        };
    }, { scrollHeight: 0, jump: 0, scrollTop: 0, changed: false }), u.filter(function (value) { return value.changed; }), u.map(function (value) { return value.jump; })), 0);
    u.connect(u.pipe(atBottomState, u.map(function (state) { return state.atBottom; })), isAtBottom);
    u.connect(u.pipe(isAtBottom, u.throttleTime(50)), atBottomStateChange);
    var scrollDirection = u.statefulStream(DOWN);
    u.connect(u.pipe(scrollContainerState, u.map(function (_a) {
        var scrollTop = _a.scrollTop;
        return scrollTop;
    }), u.distinctUntilChanged(), u.scan(function (acc, scrollTop) {
        // if things change while compensating for items, ignore,
        // but store the new scrollTop
        if (u.getValue(isScrollingBy)) {
            return { direction: acc.direction, prevScrollTop: scrollTop };
        }
        return {
            direction: scrollTop < acc.prevScrollTop ? UP : DOWN,
            prevScrollTop: scrollTop,
        };
    }, { direction: DOWN, prevScrollTop: 0 }), u.map(function (value) { return value.direction; })), scrollDirection);
    u.connect(u.pipe(scrollContainerState, u.throttleTime(50), u.mapTo(NONE)), scrollDirection);
    var scrollVelocity = u.statefulStream(0);
    u.connect(u.pipe(isScrolling, u.filter(function (value) { return !value; }), u.mapTo(0)), scrollVelocity);
    u.connect(u.pipe(scrollTop, u.throttleTime(100), u.withLatestFrom(isScrolling), u.filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], isScrolling = _b[1];
        return !!isScrolling;
    }), u.scan(function (_a, _b) {
        var _c = __read(_a, 2), _ = _c[0], prev = _c[1];
        var _d = __read(_b, 1), next = _d[0];
        return [prev, next];
    }, [0, 0]), u.map(function (_a) {
        var _b = __read(_a, 2), prev = _b[0], next = _b[1];
        return next - prev;
    })), scrollVelocity);
    return {
        isScrolling: isScrolling,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        atBottomState: atBottomState,
        atTopStateChange: atTopStateChange,
        atBottomStateChange: atBottomStateChange,
        scrollDirection: scrollDirection,
        atBottomThreshold: atBottomThreshold,
        scrollVelocity: scrollVelocity,
        lastJumpDueToItemResize: lastJumpDueToItemResize,
    };
}, u.tup(domIOSystem));
